import { render } from "./CustomLinkDownload.vue?vue&type=template&id=6d9da842&scoped=true"
import script from "./CustomLinkDownload.vue?vue&type=script&lang=js"
export * from "./CustomLinkDownload.vue?vue&type=script&lang=js"

import "./CustomLinkDownload.vue?vue&type=style&index=0&id=6d9da842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9da842"]])

export default __exports__